// extracted by mini-css-extract-plugin
export default {"video":"BackgroundLoopVideo_video__udJ7W","preload":"BackgroundLoopVideo_preload__p1xMd"};